import script from "./SupportMePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportMePage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__